export default {
  'meta': {
    'langName': 'POLISH',
    'lang': 'Polski'
  },
  'title': 'WYCOFANIE PRODUKTU: HULAJNOGA ELEKTRYCZNA MARKI BTWIN, MODEL SD500E LUB MD500E',
  'description': 'Dzień dobry.\n\nZakupili Państwo hulajnogę elektryczną marki BTWIN, model SD 500E lub MD500E, i serdecznie dziękujemy za ten zakup.\n\nPaństwa bezpieczeństwo jest dla nas najważniejsze, dlatego prosimy o zapoznanie się z poniższymi informacjami.\n\nPomimo stosowania rygorystycznych procedur kontroli jakości stwierdziliśmy, że hulajnogi elektryczne BTWIN SD500E i MD500E mają wadę zagrażającą bezpieczeństwu użytkownika. Ich intensywne użytkowanie może spowodować pojawienie się pęknięcia w miejscu połączenia ramy z kolumną kierownicy. Wada ta może spowodować przerwanie tego połączenia, co stwarza ryzyko upadku użytkownika.\n\nProponujemy, aby odpowiedzieli Państwo na poniższe pytania, co pozwoli nam zaproponować Państwu rozwiązanie zapewniające bezpieczeństwo Państwa produktu.\n\nPrzepraszamy za wszelkie niedogodności i dziękujemy za zaufanie.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Na początek prosimy o potwierdzenie adresu e-mail oraz kraju zamieszkania:'
  },
  'fields': {
    'country': 'Kraj',
    'address': 'Adres e-mail',
    'email': 'Adres e-mail',
    'phonePrefix': 'Numer kierunkowy',
    'phone': 'Numer telefonu',
    'validations': {
      'phoneOrEmail': 'Prosimy o podanie przynajmniej adresu e-mail lub numeru telefonu.',
      'email': 'Wprowadź poprawny adres e-mail',
      'phone': 'Wprowadź prawidłowy numer telefonu',
      'selectAddress': 'Proszę wybrać pełny adres z listy (numer domu, nazwa ulicy i miasto).',
      'incompleteAddress': 'Adres musi zawierać numer domu, nazwę ulicy oraz nazwę miasta. Proszę wpisać przynajmniej numer i nazwę ulicy, a następnie wybrać jedną z propozycji.'
    },
    'firstName': 'Nazwisko',
    'lastName': 'Imię',
    'deliveryAddress': 'Adres dostawy przesyłki',
    'additionalAddress': 'Dodatkowe informacje dotyczące adresu',
    'city': 'Miasto',
    'zip': 'Kod pocztowy',
    'readConfirmation': 'Oświadczam, że podane przeze mnie dane kontaktowe są prawdziwe i potwierdzam, że zapoznałem(-łam) się z przedstawionymi warunkami i zobowiązuję się do ich przestrzegania.',
    'choose': 'Wybierz',
    'required': 'To pole jest obowiązkowe',
    'deliveryAddressHelp': 'Proszę wpisać numer i nazwę ulicy, a następnie wybrać pełny adres z listy.',
    'streetOnlyHint': 'Proszę dodać numer ulicy'
  },
  'ownerCheck': {
    'title': 'Czy nadal jest Pan/Pani właścicielem/właścicielką jednej lub kilku hulajnóg elektrycznych BTWIN SD500E i MD500E?'
  },
  'yes': 'TAK',
  'no': 'NIE',
  'ownerChanged': {
    'title': 'Czy dysponuje Pan/Pani danymi kontaktowymi obecnego właściciela (obecnych właścicieli)?',
    'confirmation': 'Szanowny Panie/Szanowna Pani,\n\ndziękujemy za udział w tej inicjatywie na rzecz poprawy jakości.\n\nPrzepraszamy za niedogodności i dziękujemy za zaufanie.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Proszę podać liczbę hulajnóg elektrycznych BTWIN SD500E i MD500E.',
    'descriptionSd500': 'Hulajnogi elektryczne SD500E',
    'descriptionEmd500e': 'Hulajnogi elektryczne MD500E',
    'modelNumberHelp': 'Numer modelu (SD500E lub MD500E) znajduje się pod hulajnogą, jak pokazano poniżej.',
    'quantity': 'Ilość',
    'confirmation': 'Dziękujemy za wypełnienie tego formularza. Państwa zgłoszenie zostało pomyślnie zarejestrowane.\n\nPoinformujemy Państwa w ciągu maksymalnie 20 dni o terminie, od którego będzie można przeprowadzić naprawę.\n\nŻyczymy miłego dnia,\n\nDECATHLON'
  },
  'repair': {
    'title': 'Naprawa wykonana samodzielnie',
    'description': 'Prosimy o zaprzestanie korzystania z produktu.\n\nZestaw naprawczy wraz z instrukcją zostanie wysłany na Państwa adres domowy, aby mogli Państwo zabezpieczyć swoją hulajnogę. Zestaw ten zostanie wysłany do Państwa bezpłatnie, a jego montaż jest szybki i łatwy.\n\nPo otrzymaniu Państwa danych skontaktujemy się z Państwem w ciągu maksymalnie 20 dni w celu ustalenia terminu, od którego będzie można przeprowadzić naprawę. Zapewniamy, że dołożymy wszelkich starań, aby ograniczyć te opóźnienia i spełnić Państwa oczekiwania.',
    'videoLink': 'Link do filmiku instruktażowego',
    'kitLabel': 'Kompletny zestaw naprawczy',
    'docLabel': 'Instrukcja naprawy',
    'callToAction': 'Należy kliknąć tutaj, aby otrzymać bezpłatny zestaw naprawczy.',
    'infoConfirmation': 'Prosimy o weryfikację poprawności Państwa danych',
    'validateConfirmation': 'Potwierdź',
    'backConfirmation': 'Wróć'
  },
  'repairRequest': {
    'title': 'Aby otrzymać zestaw naprawczy, należy podać następujące informacje:'
  },
  'form': {
    'submit': 'Dalej'
  },
  'status': 'Translation validated by COUNTRY'
} as const
